import { useState } from 'react';
import { faqList } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
              FAQ
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              常见问题速答
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于版本区别、字幕在线是否需要下载、不同字幕组能否混看、分集状态的含义等问题，
              都在这里集中回答。点击问题即可展开答案。
            </p>
            <div className="mt-6 flex items-start gap-3 rounded-md bg-secondary-50 p-4">
              <i className="ri-lightbulb-line mt-0.5 text-lg text-secondary-600" aria-hidden="true"></i>
              <p className="text-sm leading-relaxed text-secondary-900">
                建议先固定一个字幕组的译名表连续观看，中途换版最容易在称谓上产生混淆。
              </p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <ul className="space-y-3">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li
                    key={item.question}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-100/70"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                        {item.question}
                      </span>
                      <i
                        className={`shrink-0 text-lg text-primary-600 transition-transform ${
                          isOpen ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="border-t border-background-200 bg-background-50 px-5 py-4">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}